import { ApiService } from "@/api";

export const createLittleGroup = (groupId: string, users: string[]) => {
  return ApiService.baseAction(
    `/little-group/${groupId}/create`,
    {
      data: {
        users: users,
      },
    },
    "post"
  );
};
